class Article extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.domElements();
    this.initImageSlider();
  }

  domElements() {
    // image slider
    this.imageSlider = this.querySelector(".blog-article__images__slider");
    this.sliderPagination = this.querySelector(".swiper__pagination");
  }

  initImageSlider() {
    this.productImages = new Swiper(this.imageSlider, {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: this.sliderPagination,
        clickable: true,
      },
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: true,
      // },
      keyboard: {
        enabled: true,
      },
    });
  }

  disconnectedCallback() {
    console.log("article disconnected");
  }
}

customElements.define("blog-article", Article);
